import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SystemConfigurationService {

  private config: any;

  constructor(
    private http: HttpClient,
    private handler: HttpBackend,
  ) {}

  async getConfiguration(): Promise<any> {
    this.http = new HttpClient(this.handler);
    const header = new HttpHeaders({ 'Accept': 'application/json' });
    return this.http.get<any>(`${environment.endPointApiLogin}/api/system-configuration/`, { headers: header })
      .toPromise()
      .then(res => this.config = res);
  }

  get isMaintenanceMode(): boolean {
    if (this.config) {
      for (const item of this.config) {
        if (item.tag === 'MANTENIMIENTO') {
          return item.value;
        }
      }
    }
    return false;
  }
}
